import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Button } from '@mui/material';

// import { useNavigate } from 'react-router-dom';
import Switch from '@mui/material/Switch';
import api from '../../API/api';
import GeneralAction from '../panel/generalAction';
import FormDialog from '../panel/modal';
import ViewBlog from '../blogs/viewBlog';



export default function BlogFromPublic(props) {

    // const navigation = useNavigate()

    // const [events, setEvents] = useState();
    const [blogs, setBlogs] = useState();

    useEffect(() => {
        getBlogs()

    }, [])


    const getBlogs = () => {
        api.getBlogs().then((res) => {
            // console.log(res);
            setBlogs(res.data.blogs.filter((el) => el.isApprove === 0))
        })
            .catch((err) => {
                // console.log(err.response);
            })
    }

    // const [status, setStatus] = useState(true);

    const changeBlogStatus = (id, status) => {
        // console.log(id, status);
        api.changeBlogStatus(id, status).then((res) => {
            // console.log(res);
            getBlogs();
        })
            .catch((err) => {
                // console.log(err.response);
            })
    }

    const [open, setOpen] = React.useState(false);
    const [modalData, setModalData] = React.useState();

    const handleClickOpen = (data) => {
        setOpen(true);
        setModalData(data)
    };
    const handleClose = () => {
        setOpen(false);
    };




    return (
        <div className='py-3'>
            {/* <div className="row">
                <div className='py-3'>
                    <Button variant='contained' color='error' fullWidth>{props.school && props.school.schoolName}</Button>
                </div>
            </div> */}

            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                    <TableHead sx={{ backgroundColor: 'black' }}>
                        <TableRow>
                            <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }}>Title</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }}>Author</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }} >Cover</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }} >Date</TableCell>

                            <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }} >Status</TableCell>

                            <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }} align="right">Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {blogs && blogs.map((row) => (
                            <TableRow
                                key={row.id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell > {row.title} </TableCell>
                                <TableCell > {row.author} </TableCell>
                                <TableCell >
                                    <img src={`${process.env.REACT_APP_BACKEND}blogs/thumb/${row.cover}`} height={50} />
                                </TableCell>
                                <TableCell > {row.date} </TableCell>
                                <TableCell > {row.isApprove === 0 ? <span className='bg-danger text-white p-1'>Inactive</span>: <span className='bg-success'>Active</span>} </TableCell>
                                {/* <TableCell > {row.isActive === 1 ?
                                    <span className='text-success'>
                                        Active
                                    </span>
                                    :
                                    <span className='text-danger'>
                                        Inactive
                                    </span>

                                }
                                    <Switch
                                        checked={row.isActive}
                                        onChange={() => changeBlogStatus(row.id, row.isActive)}
                                        name="loading"
                                        color="primary"
                                    />
                                </TableCell> */}
                                <TableCell align="right">
                                     <Button size='small'>
                                         <GeneralAction 
                                         data={row} 
                                         handleClickOpen={props.handleClickOpen}
                                          handleClickOpenView={handleClickOpen}
                                          type="blog"
                                            /> 
                                     </Button> </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>


            <FormDialog form={<ViewBlog blog={modalData} from="notApproved" handleClose={handleClose} getBlogs={getBlogs}/>} title='Public Blog' open={open} handleClickOpenView={handleClickOpen} handleClose={handleClose} />


        </div>
    );
}